// Drag scroll fluido para filtro de tallas
(function() {
  'use strict';

  function initSizeDragScroll() {
    const sizeFilters = document.querySelectorAll('.filtro_tallas ul');
    
    sizeFilters.forEach(container => {
      if (container.dataset.dragInitialized) return;
      
      let isDown = false;
      let startX;
      let scrollLeft;
      let velocity = 0;
      let lastX = 0;
      let lastTime = Date.now();

      container.addEventListener('mousedown', (e) => {
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        velocity = 0;
        lastX = e.pageX;
        lastTime = Date.now();
        e.preventDefault();
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.style.cursor = 'grab';
        
        // Momentum scrolling
        if (Math.abs(velocity) > 0.5) {
          let momentum = velocity;
          const deceleration = 0.95;
          
          const momentumScroll = () => {
            momentum *= deceleration;
            container.scrollLeft -= momentum;
            
            if (Math.abs(momentum) > 0.5) {
              requestAnimationFrame(momentumScroll);
            }
          };
          
          requestAnimationFrame(momentumScroll);
        }
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 1.5;
        container.scrollLeft = scrollLeft - walk;
        
        // Calculate velocity
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) {
          velocity = (e.pageX - lastX) / dt * 16;
        }
        lastX = e.pageX;
        lastTime = now;
      });

      // Touch support
      let touchStartX = 0;
      let touchScrollLeft = 0;

      container.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].pageX - container.offsetLeft;
        touchScrollLeft = container.scrollLeft;
      }, { passive: true });

      container.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX - container.offsetLeft;
        const walk = (x - touchStartX) * 1.5;
        container.scrollLeft = touchScrollLeft - walk;
      }, { passive: true });

      container.dataset.dragInitialized = 'true';
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeDragScroll);
  } else {
    initSizeDragScroll();
  }

  // Re-initialize after facet updates
  if (typeof FacetFiltersForm !== 'undefined') {
    const originalRender = FacetFiltersForm.renderProductGridContainer;
    if (originalRender) {
      FacetFiltersForm.renderProductGridContainer = function(html) {
        originalRender.call(this, html);
        setTimeout(initSizeDragScroll, 100);
      };
    }
  }

  // Observer for dynamic content
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        const hasSizeFilter = Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 && (
            node.classList?.contains('filtro_tallas') ||
            node.querySelector?.('.filtro_tallas')
          )
        );
        if (hasSizeFilter) {
          setTimeout(initSizeDragScroll, 50);
          break;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
